const DisputeState = {
    disputes: {
        data: []
    },
};

export default DisputeState;